import { List } from '@mui/material';
import identity from 'lodash.identity';
import React from 'react';
import { useTranslation } from 'react-i18next';
import dataViewIconUrl from '../../../../../../assets/image/sidebarIcons/dataView.png';
import { useDashboardPageOptionsContext } from '../dashboards/contexts';
import { SideBarListItem } from './SideBarListItem';
import { IntercomArticleKeys } from './types';

export const SideBarMiddle = () => {
  const { t } = useTranslation();
  const options = useDashboardPageOptionsContext();
  const showDataView = options.dataView?.enabled ?? true;
  return (
    <List>
      <SideBarListItem
        disabled={!showDataView}
        iconUrl={dataViewIconUrl}
        text={t('common:dashboardSideBar.dataView')}
        onClick={identity}
        className="intercom_sidebar_dataview"
        key="dataview"
        intercomArticleKey={IntercomArticleKeys.DATA_VIEW}
      />
    </List>
  );
};
